export default {
      id: "ar-entreprendre-usage",
      viewBox: "0 0 65 65",
      url: "../dist/images/" + "sprite.svg#ar-entreprendre-usage",
      toString: function () {
        return this.url;
      }
    }